(() => {
  const translatedSortBy = window.ampemaThemeTranslations?.sortBy;
  if (!translatedSortBy) return;

  let observer;

  const applyTranslation = () => {
    const labels = document.querySelectorAll('.jdgm-sort-dropdown-label');
    if (!labels.length) return false;

    labels.forEach((label) => {
      if (label.textContent.trim() === 'Sort by') {
        label.textContent = translatedSortBy;
      }
    });

    return true;
  };

  if (applyTranslation()) return;

  observer = new MutationObserver(() => {
    if (applyTranslation()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
